import { createContext, useState } from 'react';

const AuthContext = createContext({
  authSearchData: '',
  authCode: '',
  accessToken: '',
  authErr: '',
  authMd: '',
  pkce: {},
  setAuthSearchData: () => {},
  setAuthCode: () => {},
  setAccessToken: () => {},
  setAuthErr: () => {},
  setAuthMd: () => {},
  setPkce: () => {}
});


function IUAContextProvider(props) {
  const [iuaAuthSearchData, setIuaAuthSearchData] = useState('');
  const [iuaAuthCode, setIuaAuthCode] = useState('');
  const [iuaAccessToken, setIuaAccessToken] = useState('');
  const [iuaAuthErr, setIuaAuthErr] = useState('');
  const [iuaAuthMd, setIuaAuthMd] = useState('');
  const [iuaPkce, setIuaPkce] = useState({});

  function setAuthSearchData(data) {
    return setIuaAuthSearchData(() => {
      return data;
    });
  }

  function setAuthCode(data) {
    return setIuaAuthCode(() => {
      return data;
    });
  }
  
  function setAccessToken(data) {
    return setIuaAccessToken(() => {
      return data;
    });
  }
  
  function setAuthErr(data) {
    return setIuaAuthErr(() => {
      return data;
    });
  }

  function setAuthMd(data) {
    return setIuaAuthMd(() => {
      return data;
    });
  }    

  function setPkce(data) {
    return setIuaPkce(() => {
      return data;
    });
  }
  
  function clear() {
    setAuthSearchData('');
    setAuthCode('');
    setAccessToken('');
    setAuthErr('');
    setAuthMd('');
    setPkce('');
  }

  const context = {
    authSearchData: iuaAuthSearchData,
    setAuthSearchData: setAuthSearchData,
    authCode: iuaAuthCode,
    setAuthCode: setAuthCode,
    accessToken: iuaAccessToken,
    setAccessToken: setAccessToken,
    authErr: iuaAuthErr,
    setAuthErr: setAuthErr,
    authMd: iuaAuthMd,
    setAuthMd: setAuthMd,
    pkce: iuaPkce,
    setPkce: setPkce,
    clear: clear
  }

  return (
    <AuthContext.Provider value={context}>
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
export { IUAContextProvider };
